export default "__VITE_ASSET__Byf$Vc7T__"